var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ButtonDefinitive',{staticClass:"ps-do-step-2",attrs:{"label":"Continuar"},on:{"click":_vm.next}})}
var staticRenderFns = []

export { render, staticRenderFns }